(() => {
  if (window.__dolceCartDeliveryFinalLoaded) return;
  window.__dolceCartDeliveryFinalLoaded = true;

  const grupoA=['Villa Alemana','Quilpué','Viña del Mar','Concón','Reñaca','Valparaíso'];
  const grupoB=['Quillota','La Cruz','La Calera'];
  const stgo=['Cerro Navia','Cerrillos','Lo Prado','San Joaquín','Pedro Aguirre Cerda','Lo Barnechea','Providencia','Las Condes','Vitacura','Santiago Centro','Ñuñoa','Peñalolén','Maipú','La Florida','La Reina','Estación Central','Conchalí','Colina','Huechuraba','Macul','La Cisterna','San Miguel','Independencia','Quinta Normal','Renca','Recoleta','Pudahuel','La Granja','San Ramón'];
  const express=['Las Condes','Providencia','Ñuñoa','Vitacura','La Reina'];
  const bloqueadasTodas=new Set(['2026-04-24','2026-04-25','2026-06-19','2026-06-20','2026-08-06','2026-10-31','2026-10-12','2026-09-17','2026-09-25']);
  const bloqueadasStgo=new Set(['2026-06-19','2026-07-04','2026-07-08']);
  const bloqueadasExpress=new Set(['2026-09-10']);
  const bloqueadasV=new Set(['2026-07-04']);
  const specialVariantIds=new Set([
    '52509704814808', // 2 Pack $58.990
    '52527534899416'  // Venta privada 2 Pack $55.990
  ]);
  const states=new WeakMap();
  let checkoutBusy=false;
  let scanFrame=0;

  const chileNow=()=>new Date(new Date().toLocaleString('en-US',{timeZone:'America/Santiago'}));
  const iso=(date)=>`${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  const pretty=(date)=>date.toLocaleDateString('es-CL',{weekday:'long',day:'numeric',month:'long'});
  const short=(date)=>date.toLocaleDateString('es-CL',{weekday:'short',day:'numeric',month:'short'});

  function checkoutUrl(commune){
    const isSantiago=stgo.includes(commune);
    const province=isSantiago?'Santiago':'Valparaíso';
    const provinceCode=isSantiago?'RM':'VS';
    const params=new URLSearchParams();
    params.set('checkout[shipping_address][country]','Chile');
    params.set('checkout[shipping_address][country_code]','CL');
    params.set('checkout[shipping_address][city]',commune);
    params.set('checkout[shipping_address][province]',province);
    params.set('checkout[shipping_address][province_code]',provinceCode);
    return `/checkout?${params.toString()}`;
  }

  function datesFor(commune,longBooking=false){
    const isStgo=stgo.includes(commune), isExpress=express.includes(commune);
    const isLoBarnechea=commune==='Lo Barnechea';
    const isMaipuPudahuel=['Maipú','Pudahuel'].includes(commune);
    const isV=grupoA.includes(commune)||grupoB.includes(commune), isQL=['Quillota','La Cruz'].includes(commune);
    const allowed=
      grupoA.includes(commune)?[4]:
      grupoB.includes(commune)?[1,2,3,4,5]:
      isLoBarnechea?[2,6]:
      isMaipuPudahuel?[3,5]:
      isStgo?[2,3,5,6]:
      [1,2,3,4,5,6];
    const now=chileNow(), today=new Date(now); today.setHours(0,0,0,0);
    const tomorrow=new Date(today); tomorrow.setDate(today.getDate()+1);
    const minutes=now.getHours()*60+now.getMinutes();

    // ── EXCEPCIÓN HOY 26/08/2026 ──────────────────────────────────────
    const comunasExcepcionHoy=['Recoleta','Santiago Centro','Independencia','Conchalí','Huechuraba'];
    const esExcepcionHoy=comunasExcepcionHoy.includes(commune)&&iso(today)==='2026-08-26';
    // ─────────────────────────────────────────────────────────────────

    const stgoCutoff=[0,6].includes(now.getDay())?840:780; // L-V → 13:00, S-D → 14:00
    const excludeToday=
      isExpress?minutes>=1020:
      (isLoBarnechea||isMaipuPudahuel)?minutes>=600:
      esExcepcionHoy?minutes>=1020:   // excepción hoy → 17:00
      isStgo?minutes>=stgoCutoff:
      isQL?minutes>=1080:
      minutes>=420;
    const excludeTomorrow=isStgo&&now.getHours()===23&&now.getMinutes()>=59;
    const results=[];
    const lastDay=new Date(today.getFullYear(),today.getMonth()+4,0);
    const daysToScan=longBooking
      ?Math.ceil((lastDay.getTime()-today.getTime())/86400000)+1
      :35;

    for(let i=0;i<daysToScan&&(longBooking||results.length<3);i++){
      const d=new Date(today);
      d.setDate(today.getDate()+i);
      d.setHours(0,0,0,0);

      const id=iso(d);
      const isToday=d.getTime()===today.getTime();
      const isTomorrow=d.getTime()===tomorrow.getTime();

      const blocked=
        bloqueadasTodas.has(id) ||
        (isStgo&&bloqueadasStgo.has(id)) ||
        (isExpress&&bloqueadasExpress.has(id)) ||
        (isV&&bloqueadasV.has(id));

      if(
        allowed.includes(d.getDay()) &&
        !(excludeToday&&isToday) &&
        !(excludeTomorrow&&isTomorrow) &&
        !blocked
      ){
        results.push({
          iso:id,
          text:pretty(d),
          short:short(d),
          date:new Date(d)
        });
      }
    }

    return results;
  }

  function selectDate(root,button,date,save=true){
    const {commune,options,summary}=els(root);
    options.querySelectorAll('.dolce-delivery-v2__option').forEach((item)=>item.classList.remove('is-selected'));
    button.classList.add('is-selected');
    summary.textContent=`📍 Tu entrega será el ${date.text}`;
    if(save){ saveGeneral(root,commune.value,date); }
  }

  function renderCalendar(root,dates,chosen,save){
    const {commune,options,summary}=els(root);
    const calendar=document.createElement('div');
    calendar.className='dolce-calendar';
    const now=chileNow();
    const firstMonth=new Date(now.getFullYear(),now.getMonth(),1);
    const lastMonth=new Date(now.getFullYear(),now.getMonth()+3,1);
    let shown=chosen?.date?new Date(chosen.date.getFullYear(),chosen.date.getMonth(),1):firstMonth;

    // The Horizon cart drawer closes when a click target is removed before the
    // event finishes bubbling. Month navigation redraws its buttons, so keep
    // every calendar click inside the drawer before replacing those nodes.
    calendar.addEventListener('click',(event)=>event.stopPropagation());

    const draw=()=>{
      calendar.replaceChildren();
      const head=document.createElement('div');
      head.className='dolce-calendar__head';
      const prev=document.createElement('button');
      prev.type='button'; prev.className='dolce-calendar__nav'; prev.textContent='‹';
      prev.setAttribute('aria-label','Mes anterior');
      prev.disabled=shown.getTime()<=firstMonth.getTime();
      const title=document.createElement('div');
      title.className='dolce-calendar__month';
      title.textContent=shown.toLocaleDateString('es-CL',{month:'long',year:'numeric'});
      const next=document.createElement('button');
      next.type='button'; next.className='dolce-calendar__nav'; next.textContent='›';
      next.setAttribute('aria-label','Mes siguiente');
      next.disabled=shown.getTime()>=lastMonth.getTime();
      prev.addEventListener('click',(event)=>{
        event.preventDefault();
        event.stopPropagation();
        shown=new Date(shown.getFullYear(),shown.getMonth()-1,1);
        draw();
      });
      next.addEventListener('click',(event)=>{
        event.preventDefault();
        event.stopPropagation();
        shown=new Date(shown.getFullYear(),shown.getMonth()+1,1);
        draw();
      });
      head.append(prev,title,next);
      calendar.appendChild(head);

      const week=document.createElement('div');
      week.className='dolce-calendar__week';
      ['L','M','M','J','V','S','D'].forEach((label)=>{ const span=document.createElement('span'); span.textContent=label; week.appendChild(span); });
      calendar.appendChild(week);
      const grid=document.createElement('div');
      grid.className='dolce-calendar__grid';
      const startOffset=(shown.getDay()+6)%7;
      for(let i=0;i<startOffset;i++){ const blank=document.createElement('span'); grid.appendChild(blank); }
      const monthEnd=new Date(shown.getFullYear(),shown.getMonth()+1,0).getDate();
      for(let day=1;day<=monthEnd;day++){
        const current=new Date(shown.getFullYear(),shown.getMonth(),day);
        const date=dates.find((item)=>item.iso===iso(current));
        const button=document.createElement('button');
        button.type='button';
        button.textContent=String(day);
        button.className=`dolce-calendar__day${date?' dolce-delivery-v2__option is-available':''}${date?.iso===chosen?.iso?' is-selected':''}`;
        if(!date){ button.disabled=true; button.setAttribute('aria-label',`${day}, no disponible`); }
        else{
          button.dataset.dateIso=date.iso;
          button.dataset.dateText=date.text;
          button.setAttribute('aria-label',date.text);
          button.addEventListener('click',(event)=>{
            event.preventDefault();
            event.stopPropagation();
            chosen=date;
            selectDate(root,button,date,true);
          });
        }
        grid.appendChild(button);
      }
      calendar.appendChild(grid);
      const hint=document.createElement('p');
      hint.className='dolce-calendar__hint';
      hint.textContent='Puedes reservar hasta 3 meses hacia adelante.';
      calendar.appendChild(hint);
    };
    draw();
    options.appendChild(calendar);
    if(chosen){
      summary.textContent=`📍 Tu entrega será el ${chosen.text}`;
      if(save){ saveGeneral(root,commune.value,chosen); }
    }
  }

  function els(root){
    return{
      commune:root.querySelector('[data-dolce-commune-v2]'),
      wrap:root.querySelector('[data-dolce-dates-v2]'),
      options:root.querySelector('[data-dolce-date-options-v2]'),
      summary:root.querySelector('[data-dolce-summary-v2]'),
      status:root.querySelector('[data-dolce-status-v2]'),
      error:root.querySelector('[data-dolce-error-v2]')
    };
  }

  function message(root,type,text){
    const {status,error}=els(root);
    if(type==='error'){
      if(status) status.textContent='';
      if(error){ error.hidden=false; error.textContent=text; }
    }else{
      if(error){ error.hidden=true; error.textContent=''; }
      if(status) status.textContent=text||'';
    }
  }

  function selected(root){
    const button=root.querySelector('.dolce-delivery-v2__option.is-selected');
    return button
      ?{ iso:button.dataset.dateIso||'', text:button.dataset.dateText||'' }
      :null;
  }

  async function updateCart(attributes,note){
    const response=await fetch('/cart/update.js',{
      method:'POST',
      credentials:'same-origin',
      cache:'no-store',
      headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body:JSON.stringify({ attributes, note })
    });
    if(!response.ok){ throw new Error(`cart/update ${response.status}`); }
    return response.json();
  }

  async function saveGeneral(root,commune,date){
    const state=states.get(root);
    if(!state) return false;
    const signature=`${commune}|${date.iso}`;
    if(root.dataset.savedCommune===commune&&root.dataset.savedDate===date.text){
      message(root,'status','✓ Datos de entrega guardados');
      return true;
    }
    if(state.promise&&state.signature===signature){ return state.promise; }
    state.signature=signature;
    root.setAttribute('aria-busy','true');
    message(root,'status','Guardando datos de entrega…');
    const attributes={
      'Comuna de entrega':commune,
      'Fecha de entrega':date.text,
      'Comuna elegida':null,
      'Región':null,
      'Fecha de entrega ISO':null
    };
    const note=`Entrega Dolcebarquillo — Comuna: ${commune} | Fecha: ${date.text}`;
    state.promise=updateCart(attributes,note)
      .then((cart)=>{
        if(
          cart?.attributes?.['Comuna de entrega']!==commune ||
          cart?.attributes?.['Fecha de entrega']!==date.text ||
          cart?.note!==note
        ){ throw new Error('Shopify no confirmó los datos'); }
        root.dataset.savedCommune=commune;
        root.dataset.savedDate=date.text;
        message(root,'status','✓ Datos de entrega guardados');
        return true;
      })
      .catch((error)=>{
        console.error('Dolce delivery:',error);
        message(root,'error','No pudimos guardar los datos de entrega. Intenta nuevamente.');
        return false;
      })
      .finally(()=>{ state.promise=null; root.removeAttribute('aria-busy'); });
    return state.promise;
  }

  function normalizeProperties(properties){
    if(!properties) return {};
    if(Array.isArray(properties)){
      return Object.fromEntries(
        properties.map((item)=>[item.name||item[0],item.value||item[1]]).filter(([key])=>key)
      );
    }
    return {...properties};
  }

  async function attachDeliveryToLines(commune,date){
    const signal=AbortSignal.timeout(10000);
    const cartResponse=await fetch('/cart.js',{
      credentials:'same-origin',
      cache:'no-store',
      headers:{ Accept:'application/json' },
      signal
    });
    if(!cartResponse.ok){ throw new Error('No se pudo leer el carrito'); }
    const cart=await cartResponse.json();
    for(let index=cart.items.length-1;index>=0;index--){
      const item=cart.items[index];
      const properties=normalizeProperties(item.properties);
      delete properties['Fecha de entrega ISO'];
      delete properties['_Fecha de entrega ISO'];
      properties['Comuna de entrega']=commune;
      properties['Fecha de entrega']=date.text;
      const response=await fetch('/cart/change.js',{
        method:'POST',
        credentials:'same-origin',
        cache:'no-store',
        headers:{ 'Content-Type':'application/json', Accept:'application/json' },
        body:JSON.stringify({ id:item.key, quantity:item.quantity, properties }),
        signal
      });
      if(!response.ok){ throw new Error(`No se pudo actualizar el producto ${index+1}`); }
      await response.json();
    }
    const verifyResponse=await fetch('/cart.js',{
      credentials:'same-origin',
      cache:'no-store',
      headers:{ Accept:'application/json' },
      signal
    });
    if(!verifyResponse.ok){ throw new Error('No se pudo verificar el carrito'); }
    const verified=await verifyResponse.json();
    const correct=verified.items.every((item)=>{
      const props=normalizeProperties(item.properties);
      return(
        props['Comuna de entrega']===commune &&
        props['Fecha de entrega']===date.text &&
        !props['Fecha de entrega ISO'] &&
        !props['_Fecha de entrega ISO']
      );
    });
    if(!correct){ throw new Error('Los productos no conservaron los datos de entrega'); }
    return true;
  }

  function render(root,save){
    const { commune, wrap, options, summary }=els(root);
    if(!commune||!wrap||!options||!summary) return;
    options.replaceChildren();
    summary.textContent='';
    message(root,'status','');
    if(!commune.value){ wrap.hidden=true; return; }
    const longBooking=root.dataset.longBooking==='true';
    const dates=datesFor(commune.value,longBooking);
    wrap.hidden=false;
    const saved=root.dataset.savedCommune===commune.value?root.dataset.savedDate:'';
    const chosen=dates.find((date)=>date.text===saved||date.iso===saved)||dates[0];
    if(longBooking){
      renderCalendar(root,dates,chosen,save);
      return;
    }
    dates.forEach((date)=>{
      const button=document.createElement('button');
      button.type='button';
      button.className=`dolce-delivery-v2__option${date.iso===chosen?.iso?' is-selected':''}`;
      button.textContent=date.short;
      button.dataset.dateIso=date.iso;
      button.dataset.dateText=date.text;
      button.addEventListener('click',()=>{
        selectDate(root,button,date,true);
      });
      options.appendChild(button);
    });
    if(chosen){
      summary.textContent=`📍 Tu entrega será el ${chosen.text}`;
      if(save){ saveGeneral(root,commune.value,chosen); }
    }
  }

  async function syncBookingMode(root){
    const state=states.get(root);
    if(!state||state.modeChecked||state.modePromise) return;
    state.modePromise=fetch('/cart.js',{
      credentials:'same-origin',
      cache:'no-store',
      headers:{ Accept:'application/json' }
    })
      .then((response)=>{
        if(!response.ok){ throw new Error(`cart ${response.status}`); }
        return response.json();
      })
      .then((cart)=>{
        const hasSpecial=cart.items.some((item)=>specialVariantIds.has(String(item.variant_id)));
        const nextValue=hasSpecial?'true':'false';
        const changed=root.dataset.longBooking!==nextValue;
        root.dataset.longBooking=nextValue;
        state.modeChecked=true;
        if(changed&&state.commune.value){ render(root,false); }
      })
      .catch((error)=>{ console.error('Dolce booking mode:',error); })
      .finally(()=>{ state.modePromise=null; });
    return state.modePromise;
  }

  function init(root){
    const { commune, options }=els(root);
    if(!commune||!options) return;
    const prior=states.get(root);
    if(prior&&prior.commune===commune&&prior.options===options){
      if(commune.value&&!options.childElementCount){ render(root,false); }
      syncBookingMode(root);
      return;
    }
    states.set(root,{ commune, options, promise:null, signature:'', modeChecked:false, modePromise:null });
    commune.addEventListener('change',()=>{
      root.dataset.savedCommune='';
      root.dataset.savedDate='';
      render(root,true);
    });
    if(commune.value){ render(root,false); }
    syncBookingMode(root);
  }

  function scan(){
    document.querySelectorAll('[data-dolce-delivery-v2]').forEach(init);
  }

  function schedule(){
    if(scanFrame) return;
    scanFrame=requestAnimationFrame(()=>{ scanFrame=0; scan(); });
  }

  document.addEventListener('click',async(event)=>{
    const checkout=event.target.closest(
      '[data-dolce-checkout-v2],a[href*="/checkout"],button[name="checkout"]'
    );
    if(!checkout||checkoutBusy) return;
    const roots=[...document.querySelectorAll('[data-dolce-delivery-v2]')];
    const root=roots.find((item)=>item.offsetParent!==null)||roots[0];
    if(!root) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const commune=root.querySelector('[data-dolce-commune-v2]')?.value||'';
    const date=selected(root);
    if(!commune||!date?.iso){
      message(root,'error','Selecciona tu comuna y fecha antes de ir a pagar.');
      root.scrollIntoView({ behavior:'smooth', block:'center' });
      return;
    }
    checkoutBusy=true;
    const original=checkout.textContent;
    checkout.textContent='PREPARANDO CHECKOUT…';
    checkout.setAttribute('aria-busy','true');
    message(root,'status','Abriendo el pago…');
    const saved=await saveGeneral(root,commune,date);
    if(!saved){
      checkoutBusy=false;
      checkout.textContent=original;
      checkout.removeAttribute('aria-busy');
      return;
    }
    message(root,'status','Agregando comuna y fecha al pedido…');
    try{
      await attachDeliveryToLines(commune,date);
    }catch(error){
      console.error('Dolce delivery properties:',error);
      checkoutBusy=false;
      checkout.textContent=original;
      checkout.removeAttribute('aria-busy');
      message(root,'error','No pudimos agregar la comuna y fecha al pedido. Intenta nuevamente.');
      return;
    }
    window.location.assign(checkoutUrl(commune));
  },true);

  const observer=new MutationObserver(schedule);
  observer.observe(document.documentElement,{ childList:true, subtree:true });
  document.addEventListener('cart:update',schedule);
  window.addEventListener('pageshow',schedule);
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',schedule,{once:true});
  }else{
    schedule();
  }
})();
